// Testimonials — placeholder content to be replaced with real patient testimonials.
// Keep 3-6 testimonials rotating in the Home carousel.

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    location: "Vevey",
    context: "SOPK & perte de poids",
    rating: 5,
    content:
      "Après des années de régimes inefficaces, j'ai enfin compris que mes hormones étaient en jeu. En 6 mois de suivi, j'ai perdu 9 kg, retrouvé un cycle régulier et surtout de l'énergie. L'approche globale fait toute la différence."
  },
  {
    id: 2,
    name: "Caroline B.",
    location: "Montreux",
    context: "Préménopause",
    rating: 5,
    content:
      "Je me sentais submergée par la prise de poids en préménopause. L'équipe m'a aidée à adapter mon alimentation à mes nouveaux besoins hormonaux. Je me sens à nouveau bien dans mon corps."
  },
  {
    id: 3,
    name: "Emma L.",
    location: "Clarens",
    context: "Compulsions alimentaires",
    rating: 5,
    content:
      "Les séances d'hypnopraxie ont changé mon rapport à la nourriture. Ce n'est plus une bataille quotidienne. Je recommande vivement cette approche qui traite la cause et pas seulement le symptôme."
  },
  {
    id: 4,
    name: "Julie R.",
    location: "Vevey",
    context: "Fatigue & équilibre hormonal",
    rating: 5,
    content:
      "Un accompagnement bienveillant et expert. J'ai retrouvé mon énergie et mon sommeil en quelques semaines. L'approche corps-cœur est vraiment unique dans la région."
  }
];
